import { Grid, Switch, FormControlLabel } from "@mui/material";
import Section from "../../../components/section/section";
import Container from "@mui/material/Container";
import React from "react";
import InputDate from "../../../components/inputs/date/inputDate";
import InputTime from "../../../components/inputs/time/inputTime";
import SelectCoachInput, {
  CoachOption,
} from "../../../components/inputs/coach/selectCoachInput";
import NewAppointmentProps from "./interface/newAppointmentProps";
import CoachingTypeInput from "./src/coachingTypeInput";
import SearchParticipant from "./src/searchParticipant";
import { NewAppointmentContext } from "./context/newAppointmentContext";
import CreateButton from "./src/createButton";

const NewAppointmentContainer = (): React.JSX.Element => {
  const {
    newAppointment,
    setNewAppointment,
  }: {
    newAppointment: NewAppointmentProps;
    setNewAppointment: (newAppointment: NewAppointmentProps) => void;
  } = React.useContext(NewAppointmentContext);

  return (
    <Section>
      <Container maxWidth="sm">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SelectCoachInput
              error
              required
              removeAll
              coach={newAppointment.coach}
              setCoach={(coach: CoachOption | null) => {
                setNewAppointment({
                  ...newAppointment,
                  coach: coach,
                });
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <CoachingTypeInput />
          </Grid>

          <Grid item xs={12} lg={4}>
            <InputDate
              label="Datum"
              error
              required
              date={newAppointment.date}
              setDate={(date: string) => {
                setNewAppointment({ ...newAppointment, date: date });
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <InputTime
              error
              required
              time={newAppointment.time.from}
              setTime={(time: string) => {
                setNewAppointment({
                  ...newAppointment,
                  time: { ...newAppointment.time, from: time },
                });
              }}
              label={"Von"}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <InputTime
              error
              required
              time={newAppointment.time.to}
              setTime={(time: string) => {
                setNewAppointment({
                  ...newAppointment,
                  time: { ...newAppointment.time, to: time },
                });
              }}
              label={"Bis"}
            />
          </Grid>

          <Grid item lg={12}>
            <FormControlLabel
              control={
                <Switch
                  color="secondary"
                  checked={newAppointment.directBooking}
                  onChange={(event) => {
                    setNewAppointment({
                      ...newAppointment,
                      directBooking: event.target.checked,
                    });
                  }}
                />
              }
              label="Termin direkt auf einen TN buchen?"
            />
          </Grid>

          {newAppointment.directBooking && (
            <Grid item xs={12}>
              <SearchParticipant />
            </Grid>
          )}

          <Grid
            item
            lg={12}
            sx={{
              textAlign: "center",
            }}
          >
            <CreateButton />
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
};

export default NewAppointmentContainer;
